<template>
    <div>
        <div class="flex mrl15">
        <div v-for="(item,index) in allimgData" :key="index" :idx="index" class="mrt15 mrl15 view" :id="item.i_mr_id">
            <div class="flex" style="position: relative">
                <div style="width:150px;height:100px" >
                    <img :src="item.vc_path" style="height:100%; width:100%" v-if="itype=='2'">
                    <video :src="item.vc_path" style="height:86%; width:100%" v-else controls="controls" ></video>
                </div>
                <div class="flex" style="position: absolute;left:2px;">
                    <el-checkbox-group v-model="checkrotation">
                        <el-checkbox :key="item.i_mr_id" :label="item.i_mr_id" :checked="checked"  @change="chooseItem($event, item) "><br></el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="flex" style="color:white;position: absolute;top:81px;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:150px;">
                    <span>{{item.vc_introducion}}</span>
                </div>
            </div>
        </div>
        </div>
        <div slot="footer"  class="dialog-footer mrt10 mrb10 " style="text-align: center">
            <el-button type="primary"  :class="baseerp+'btn'"  size="mini" @click="sure" >保存</el-button>
            <el-button size="mini" @click="cancel">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "../api"
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    export default {
        name: "choosePic",
        components: {},
        props:{
            pic:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                itype:"",
                thisnum:null,
                checked:false,
                baseerp:"",
                chooselist:[],
                checkrotation:[],
                arr:[],
                allimgData:[
                    /*{
                        i_mr_id:'001',
                        vc_path:"http://browser9.qhimg.com/bdm/480_296_0/t01bbd94b90e850d1d3.jpg"
                    },
                    {
                        i_mr_id:'002',
                        vc_path:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/A87FF679A2F3E71D9181A67B7542122C4/1653906906036.png"
                    },
                    {
                        i_mr_id:'003',
                        vc_path:"http://192.168.8.5:8005/resource/20223A824154B16ED7DAB899BF000B80EEEE/E4DA3B7FBBCE2345D7772B0674A318D55/1654070497612.png"
                    },
                    {
                        i_mr_id:'004',
                        vc_path:"http://browser9.qhimg.com/bdm/480_296_0/t01bbd94b90e850d1d3.jpg"
                    },
                    {
                        i_mr_id:'005',
                        vc_path:"http://browser9.qhimg.com/bdm/480_296_0/t01bbd94b90e850d1d3.jpg"
                    },{
                        i_mr_id:'006',
                        vc_path:"http://browser9.qhimg.com/bdm/480_296_0/t01bbd94b90e850d1d3.jpg"
                    }*/
                ]

            }
        },



        mounted() {
            //console.log(this.pic,"choose_pic");
            this.select=this.pic.select;
            this.itype=this.pic.i_type;
            if (this.select){
                this.checkrotation = this.select.map((item, index, arr) => {
                    //return item.fileid;
                    return item.i_mr_id ;
                });
                //console.log(this.checkrotation, "checkrotation");
            }

            this.baseerp=baseerp;
            this.getResourceList();


        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),

            change(val,index){
                //console.log("val",val,"index",index);
                this.chooselist=val;
                //console.log(this.chooselist,"chooselist");
            },

            cancel(){
              this.$emit("close");
            },



            sure(){
                //console.log(this.chooselist,"chooselist");
                //console.log(this.pic.select,"select");
                //let arr=this.chooselist.concat(this.pic.select);
                //console.log(arr,"arr");
                this.$emit('getpicvalue',this.chooselist);
                this.$emit('close');
            },

            // 获取权限id
            chooseItem(event, item) {
               //console.log("event",event);
               //console.log(this.checkrotation, "checkrotation");
               if (this.pic.select){
                    if (event) {
                        // 把选中的id存入数组
                        let map={};
                        map.i_mr_id=item.i_mr_id;
                        map.vc_path = item.vc_path;
                        let ab=[];
                        ab.push(map);
                        this.chooselist=ab.concat(this.pic.select);
                        //console.log(this.chooselist,"chooselist_pic");
                    }else{
                        this.pic.select.splice(this.pic.select.indexOf(item.i_mr_id), 1);
                        //console.log(this.pic.select,"this.pic.select_pic");
                        this.chooselist=this.pic.select;
                        //console.log(this.chooselist,"chooselist_pic");


                        /*var index_data=this.checkrotation.indexOf(item.i_mr_id);
                        console.log(index_data,"index_data");
                        if (index_data==-1){
                            this.pic.select.splice(index_data,1);
                        }*/
                    }
                }else{
                    // 如果是选中
                    if (event) {
                        // 把选中的id存入数组
                        let map={};
                        map.i_mr_id=item.i_mr_id;
                        map.vc_path = item.vc_path;
                        //map.ischoose=1
                        this.chooselist.push(map);
                    } else {
                        //如果是取消选中则从数组中删除该id
                        this.chooselist.splice(this.chooselist.indexOf(item.i_mr_id), 1);
                    }
                    //console.log(this.chooselist,"this.chooselist");
                }

            },




            //素材接口
            async getResourceList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                /*if (result.i_mr_id !== "") {
                    this.mid = result.i_mr_id
                    sessionStorage.setItem('mids', result.i_mr_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }*/
                let param = {
                    //i_mid: this.mid,
                    vc_name:"",
                    i_pageNum:"",
                    i_pageSize:"",
                    i_type:this.pic.i_type,
                };
                let res = await API.getResourceList(param);
                if (res.code == 1) {
                    this.allimgData=res.list;
                    //console.log("allimgData",this.allimgData);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },


        }
    }
</script>

<style lang="scss" scoped>

    .mrb10{
        margin-bottom: 10px;
    }

    .fr{
        float: right;
    }

    .fl{
        float: left;
    }

    .cl{
        clear: both;
    }

    .flex{
        display: flex;
        flex-wrap:wrap;
    }

    .imgList{
        width: 98%;
        margin: 20px 0;
        background-color: #FFF;
        display: flex;
        flex-wrap: wrap;
        .active{
            display: block;
            width: 196px;
            height: 196px;
            line-height: 0;
            font-size: 0;
            vertical-align: middle;
            border: 3px solid #2b89fd;
            -webkit-transform: rotate(0deg);

        }
        .active::before{
            content: "";
            position: absolute;
            right: 0;
            bottom: 0;
            border: 12px solid #2b89fd;
            border-top-color: transparent;
            border-left-color: transparent;
        }
        .active::after{
            content: "";
            display: block;
            width: 5px;
            height: 10px;
            position: absolute;
            right: 4px;
            bottom: 5px;
            border: 1px solid #fff;
            border-top-color: transparent;
            border-left-color: transparent;
            transform: rotate(45deg);
            cursor: pointer;
        }
        .img-item{
            width: 100px;
            height: 100px;
            overflow: hidden;
            background-color: #FFFFFF;
            margin: 20px;
            cursor: pointer;
            img{
                height: 100px;
            }

        }
    }


    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }
        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }

    .el-tree {

    }
    /* .tree {
         overflow: auto;
         height: calc(90vh - 80px)
     }*/


    .mrt15{
        margin-top: 15px;
    }

    .mrt10{
        margin-top: 10px;
    }
    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width:260px;
    }

    /deep/ {
        .el-tree-node__expand-icon{
            color: black;
        }

        .el-tree-node__expand-icon.is-leaf {
            color: transparent;
            cursor: default;
        }
        .el-tree-node__label {
            font-size: 17px;
        }

    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
    /*
        @media screen and (max-height: 770px) {
            .video-tree {
                //width: 420px;
                height: 530px;
            }
        }
        @media screen and (min-height: 900px) {
            .video-tree {
                //width: 530px;
                height: 685px;
            }
        }
        @media screen and (min-height: 780px) and (max-height: 830px) {
            .video-tree {
                //width: 450px;
                height: 610px;
            }
        }*/

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
        max-height: calc(80vh);
        min-height: calc(40vh);
    }


</style>